export default __webpack_public_path__ + "images/voucher-card-receipt.00f11bbee5ba344f413bdaf9c7bc1445.png";